import { render, staticRenderFns } from "./FormRenderFooter.vue?vue&type=template&id=94611808&"
import script from "./FormRenderFooter.vue?vue&type=script&lang=js&"
export * from "./FormRenderFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports